import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ThemeContext = createContext(null);
const KEY = "rehealthme-theme";
const BASE = process.env.REACT_APP_BACKEND_URL;
const BACK_OFFICE = ["/rhm", "/admin"];

// White is the default look. The super admin decides in CRM → Settings whether
// visitors get the light/dark switch at all; when it is off everyone sees white.
export function ThemeProvider({ children }) {
    const { pathname } = useLocation();
    const [appearance, setAppearance] = useState({ allow_theme_switch: false, default_theme: "light" });
    const [choice, setChoice] = useState(() => localStorage.getItem(KEY) || "light");

    useEffect(() => {
        let alive = true;
        fetch(`${BASE}/api/site/appearance`)
            .then((r) => r.json())
            .then((d) => {
                if (!alive || !d) return;
                setAppearance(d);
                if (!d.allow_theme_switch) {
                    localStorage.removeItem(KEY);
                    setChoice(d.default_theme || "light");
                }
            })
            .catch(() => {});
        return () => { alive = false; };
    }, []);

    const backOffice = BACK_OFFICE.some((p) => pathname === p || pathname.startsWith(`${p}/`));
    const theme = backOffice ? "dark"
        : appearance.allow_theme_switch ? choice : (appearance.default_theme || "light");

    useEffect(() => {
        document.documentElement.classList.toggle("light", theme === "light");
    }, [theme]);

    useEffect(() => {
        if (appearance.allow_theme_switch) localStorage.setItem(KEY, choice);
    }, [choice, appearance.allow_theme_switch]);

    const toggle = () => {
        if (!appearance.allow_theme_switch) return;
        setChoice((t) => (t === "dark" ? "light" : "dark"));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggle, canSwitch: !!appearance.allow_theme_switch }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
